<template>
  <div class="goods-detail-page qm-page-bg" v-if="orderConfirmData">
    <van-nav-bar title="确认订单" left-arrow class="qm-nav-bar" @click-left="$router.back()" fixed placeholder />

    <div class="order-details">
      <div class="shop-card qm-glass-card">
        <div class="shop-icon">
          <van-icon name="location-o" />
        </div>
        <div class="shop-info">
          <div class="shop-name">{{ orderConfirmData.shopName }}</div>
          <div class="shop-address">{{ orderConfirmData.shopAddress }}</div>
        </div>
      </div>

      <div class="section-label">商品明细</div>
      <div class="order-items qm-glass-card">
        <div class="order-item" v-for="item in orderConfirmData.goodsInfo[0].items" :key="item.uniqueId">
          <img :src="item.image" alt="" class="item-image" />
          <div class="item-info">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-specs">{{ formatPractice(item) }}</div>
          </div>
          <div class="item-price">
            <div class="count">￥{{ item.salePrice }}</div>
          </div>
        </div>
      </div>

      <div class="section-label">优惠</div>
      <div class="coupon-row qm-glass-card" @click="showCouponPopup = true">
        <div class="coupon-left">
          <van-icon name="coupon-o" />
          <span>优惠券</span>
        </div>
        <div class="coupon-right">
          <span class="coupon-value">{{ couponDisplayText }}</span>
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="section-label">备注</div>
      <div v-if="useWallet" class="wallet-tip qm-glass-card">
        将使用储值余额支付
      </div>
      <div class="remark-box qm-glass-card">
        <van-field v-model="remark" rows="2" autosize type="textarea" maxlength="50" placeholder="有什么想告诉店家的？"
          show-word-limit />
      </div>
    </div>

    <van-submit-bar :button-text="submitButtonText" @submit="onSubmit" :loading="submitting" />

    <van-popup v-model="showCouponPopup" position="bottom" round closeable :style="{ height: '60%' }">
      <div class="coupon-popup">
        <div class="popup-title">选择优惠券</div>
        <div class="coupon-list" v-if="couponList.length > 0">
          <div v-for="coupon in couponList" :key="coupon.cardId" class="coupon-item qm-glass-card" :class="{
            active: selectedCoupon && selectedCoupon.cardId === coupon.cardId,
          }" @click="selectCoupon(coupon)">
            <div class="coupon-content">
              <div class="coupon-name">{{ coupon.title }}</div>
            </div>
            <div class="coupon-checkbox">
              <van-checkbox :value="selectedCoupon && selectedCoupon.cardId === coupon.cardId
                " @click.stop />
            </div>
          </div>
        </div>
        <div class="no-coupon" v-else>暂无可用优惠券</div>
        <div class="popup-footer">
          <van-button type="primary" block class="qm-btn-primary" @click="confirmCouponSelection">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapState } from "vuex";
export default {
  name: "GoodsDetail",
  data() {
    return {
      orderInfo: null,
      orderConfirmData: null,
      orderKey: "",
      remark: "",
      showCouponPopup: false,
      couponList: [],
      selectedCoupon: null,
      submitting: false,
      gettingOrder: false,
    };
  },
  computed: {
    ...mapState(["appConfig", "uuid", "useWallet"]),
    submitButtonText() {
      return this.useWallet ? "储值支付" : "立即下单";
    },
    couponDisplayText() {
      if (this.selectedCoupon) {
        return this.selectedCoupon.title;
      }
      if (this.couponList.length > 0) {
        return `${this.couponList.length}张可用`;
      }
      return "暂无可用";
    },
  },
  async created() {
    try {
      this.orderInfo = JSON.parse(this.$route.query.orderInfo);
      console.log(this.orderInfo);
      this.remark = this.$route.query.remark || "";
      await this.getOrderConfirm();
    } catch (error) {
      this.$toast("订单信息解析失败");
      console.error(error);
      // this.$router.back();
    }
  },
  methods: {
    getErrorMessage(error) {
      if (!error) return '请求失败';
      if (typeof error === 'string') return error;
      if (error.message) return error.message;
      if (error.response && error.response.data) {
        const data = error.response.data;
        if (typeof data === 'string') return data;
        return data.message || data.msg || JSON.stringify(data);
      }
      try { return String(error); } catch (_) { return '请求失败'; }
    },
    buildWalletPayload(includeAmount = true) {
      if (!this.useWallet) {
        return {};
      }
      const fields = {
        isUseWallet: 1,
        lastSelect: { type: 6, value: true },
        payTypeCheck: 1,
      };
      if (includeAmount) {
        fields.wallet_amount = this.getWalletAmount();
      }
      return fields;
    },
    getOrderTotalAmount() {
      const items = this.orderConfirmData?.goodsInfo?.[0]?.items || this.orderInfo?.itemList || [];
      return items.reduce((sum, item) => sum + Number(item.salePrice ?? item.price ?? 0) * Number(item.num || 1), 0);
    },
    getWalletAmount() {
      const data = this.orderConfirmData;
      if (data) {
        const amount = data.actualAmount ?? data.payAmount ?? data.amount ?? data.orderAmount;
        if (amount != null && amount !== '') {
          return Number(amount);
        }
      }
      return this.getOrderTotalAmount();
    },
    applyWalletToPayload(payload, includeAmount = true) {
      const walletFields = this.buildWalletPayload(includeAmount);
      if (!walletFields.isUseWallet) {
        return payload;
      }
      if (payload.lastSelect && payload.attendCouponIds?.length) {
        delete payload.lastSelect;
      }
      return {
        ...payload,
        ...walletFields,
      };
    },
    buildRequiredList(coupon) {
      if (!coupon) return [];
      return [
        {
          id: coupon.templateId,
          name: coupon.title,
          preferentialType: 11,
          ruleEngineId: 0,
          couponList: [
            {
              couponId: coupon.cardId,
              couponName: coupon.title,
              couponTemplateId: coupon.templateId,
              id: coupon.templateId,
              preferentialType: 11,
              ruleEngineId: 0,
              platformType: 0,
            },
          ],
          promotionIndex: 6,
        },
      ];
    },
    async getOrderConfirm() {
      if (this.gettingOrder) return;
      this.gettingOrder = true;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        const payload = {
          // ...this.orderInfo,
          shopId: this.orderInfo.shopId,
          paidCardVersion: 1,
          storeId: this.appConfig.storeId,
          addrId: "",
          buyerRemarks: this.remark,
          giftCardIds: [],
          depositGiftCardTemplateIdList: [],
          usedPointExchage: 0,
          poinDeduc: 0,
          joinOrderStar: -1,
          manualGiveUpStar: 0,
          tableId: "",
          isWaiterCheck: 0,
          reservePhone: "",
          orderActivitys: [],
          items: this.orderInfo.itemList, // 直接使用从上一页传来的itemList
          isUseFlavorCard: 0,
          selectConsumerBenefit: null,
          firstTime: true,
          // lng: "lSMdD/E3UFZq4HlNHsuNaayhcPYIOC8GepGdhlMqKWw=",
          // lat: "4WpixJayuOgVRHMeSGlYuhBdoEoiZI5Z4Ik2EvPWYrg=",
          appVersion: "5.85.0",
          eVersion: "1.0",
          appid: this.appConfig.appid,
          requiredList: [],
        };
        // 清理一下从orderInfo带过来的多余字段
        delete payload.itemList;

        if (this.appConfig.name == '益和堂') {
          payload['items'][0]["attachList"] = [
            {
              "id": "830097170393366528",
              "name": "默认糖",
              "num": 1
            }
          ]

        }

        console.log('payload', payload);

        const confirmPayload = this.applyWalletToPayload(payload, false);

        const res = await request.post("/qimai/order/confirm", confirmPayload);
        if (res.code === "0") {
          this.orderConfirmData = res.data;
          this.orderConfirmData.shopName = this.orderInfo.shopName; // 从 orderInfo 中获取 shopName
          this.orderConfirmData.shopAddress = this.orderInfo.shopAddress; // 从 orderInfo 中获取 shopAddress

          if (this.couponList.length === 0) {
            this.couponList = res.data.crmCouponInfoList || [];
            if (this.couponList.length > 0) {
              this.couponList = res.data.crmCouponInfoList.filter(
                (item) => item.couponTemplate.id == this.appConfig.dataId
              );

              console.log("优惠卷列表", this.couponList);

              this.selectedCoupon = this.couponList[0];
              console.log(this.selectedCoupon);

            }
          }
        } else {
          this.$toast.fail(res.message || "加载失败");
        }
      } catch (error) {
        this.$toast.fail("请求失败");
        console.error(error);
      } finally {
        this.gettingOrder = false;
        this.$toast.clear();
      }
    },
    selectCoupon(coupon) {
      this.selectedCoupon = coupon;
    },
    confirmCouponSelection() {
      this.showCouponPopup = false;
    },
    async onSubmit() {
      if (this.submitting) return;
      this.submitting = true;

      try {
        const payload = {
          paidCardVersion: 1,
          orderType: "1",
          storeId: this.appConfig.storeId,
          shopId: this.orderInfo.shopId,
          addrId: "",
          buyerRemarks: this.remark,
          giftCardIds: [],
          depositGiftCardTemplateIdList: [],
          usedPointExchage: 0,
          poinDeduc: 0,
          joinOrderStar: -1,
          manualGiveUpStar: 0,
          tableId: "",
          isWaiterCheck: 0,
          reservePhone: "",
          orderActivitys: [],
          items: this.orderInfo.itemList,
          isUseFlavorCard: 0,
          selectConsumerBenefit: null,
          // lng: "lSMdD/E3UFZq4HlNHsuNaayhcPYIOC8GepGdhlMqKWw=",
          // lat: "4WpixJayuOgVRHMeSGlYuhBdoEoiZI5Z4Ik2EvPWYrg=",
          depositFirst: 0,
          channelCode: "",
          appVersion: "5.85.0",
          eVersion: "1.0",
          appid: this.appConfig.appid,
        };

        if (this.selectedCoupon) {
          payload.attendCouponIds = [this.selectedCoupon.cardId];
          payload.lastSelect = {
            type: -1,
            value: this.selectedCoupon.cardId,
          };
        }

        const createPayload = this.applyWalletToPayload(payload);

        const createOrderRes = await request.post('/qimai/order/create', {
          ...createPayload,
          uuid: this.uuid
        });

        if (createOrderRes.code === '0') {
          const orderNo = createOrderRes.data.orderNo;
          // 仅链接选了会员/储值支付（useWallet）时走会员支付；
          // 储值扣完应付为 0 则直接成功，否则默认走微信支付
          if (this.useWallet) {
            const payAmount = Number(createOrderRes.data.payAmount ?? 0);
            if (payAmount <= 0) {
              this.$toast.success('下单成功');
              this.$router.push({
                path: '/order-detail',
                query: { orderNo },
              });
              return;
            }
          }

          try {
            const paymentInfoRes = await request.post('/qimai/pay/payment-info', {
              orderNo: orderNo,
              storeId: this.appConfig.storeId,
              shopId: this.orderInfo.shopId,
              appid: this.appConfig.appid,
            });

            if (paymentInfoRes.code === '0' && paymentInfoRes.data) {
              // 将 orderNo 挂载到 this.orderInfo 上，以便后续方法可以访问
              this.orderInfo.orderNo = orderNo;
              await this.callWeChatPaymentAPI(paymentInfoRes.data);
            } else {
              this.$toast.fail(paymentInfoRes.message || '获取支付参数失败');
            }
          } catch (paymentError) {
            this.$toast.fail('支付请求失败，但订单已创建');
            console.error('Payment request failed', paymentError);
            // 即使支付失败，也跳转到订单详情页
            this.$router.push({
              path: '/order-detail',
              query: {
                orderNo: orderNo,
              },
            });
          }
        } else {
          this.$toast.clear();
          
          this.$toast.fail(createOrderRes.message || '下单失败');
        }
      } catch (error) {
        this.$toast.clear();
         console.log(error);
        this.$toast.fail(this.getErrorMessage(error) || '下单请求失败');
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },

    async callWeChatPaymentAPI(paymentData) {
      try {
        const reqDataObject = this.constructReqDataObject(
          paymentData,
          this.appConfig.appid
        );
        const weChatPayload = {
          appid: this.appConfig.appid,
          req_data: JSON.stringify(reqDataObject),
        };
        await request.post("/qimai/wx-payment-proxy", {
          sessionId: "37482d171094e75eb1661b09d3021062",
          payload: weChatPayload,
        });

        this.$router.push({
          path: "/order-detail",
          query: { orderNo: this.orderInfo.orderNo },
        });

        // if (res && res.uuid) {
        // 将 orderNo 挂载到 this.orderInfo 上，以便后续方法可以访问
        // this.orderInfo.orderNo = paymentData.out_trade_no;

        // this.triggerWeChatQRConnect(res.uuid);
        // } else {
        //   this.$toast.fail(res.err_msg || '获取支付凭证失败');
        // }
      } catch (error) {
        this.$toast.fail("支付代理请求失败");
        console.error("Payment proxy failed", error);
      }
    },

    async triggerWeChatQRConnect(uuid) {
      // this.$toast.loading({
      //   message: '请在微信中完成支付...',
      //   forbidClick: true,
      //   duration: 0,
      // });

      const maxRetries = 20; // 轮询20次，约1分钟
      let retries = 0;
      let lastStatus = -1;

      const poll = async () => {
        if (retries >= maxRetries) {
          this.$toast.fail("支付超时，请重试");
          return;
        }
        try {
          const res = await request.post("/qrconnect", {
            appid: this.appConfig.appid,
            uuid: uuid,
            last: lastStatus,
          });

          if (typeof res === "string") {
            if (res.includes("window.wx_code=200")) {
              this.$toast.success("支付成功！");
              // this.$router.push({
              //   path: '/order-detail',
              //   query: { orderNo: this.orderInfo.orderNo },
              // });
              return; // 支付成功，停止轮询
            }

            const errcodeMatch = res.match(/window.wx_errcode=(\d+)/);
            if (errcodeMatch) {
              const errcode = parseInt(errcodeMatch[1], 10);
              switch (errcode) {
                case 408: // 等待扫码（超时）
                  // 状态不变，继续轮询
                  break;
                case 404: // 已扫码，等待确认
                  this.$toast.loading({
                    message: "已扫码，请在手机上确认...",
                    forbidClick: true,
                    duration: 0,
                  });
                  break;
                case 405: // 已确认支付
                  this.$toast.success("支付成功！");
                  this.$router.push({
                    path: "/order-detail",
                    query: { orderNo: this.orderInfo.orderNo },
                  });
                  return; // 支付成功，停止轮询
                case 402: // 已取消
                case 403: // 二维码过期
                  this.$toast.fail("您已取消支付或二维码已过期");
                  return; // 停止轮询
                default:
                  this.$toast.fail(`支付失败，错误码: ${errcode}`);
                  return; // 停止轮询
              }
            }
          } else {
            this.$toast.fail("支付状态查询异常");
            console.error("QRConnect poll returned unexpected data", res);
            return; // 停止轮询
          }

          // 从返回的脚本中解析出 lastStatus 以用于下一次请求
          const match = res.match(/last\s*=\s*(\d+)/);
          if (match) {
            lastStatus = match[1];
          }

          retries++;
          setTimeout(poll, 3000); // 3秒后再次轮询
        } catch (error) {
          this.$toast.fail("支付状态查询失败");
          console.error("QRConnect poll failed", error);
        }
      };

      poll(); // 开始轮询
    },

    constructReqDataObject(paymentData, appid) {
      const args = {
        adUxInfo: "",
        timeStamp: paymentData.timeStamp,
        nonceStr: paymentData.nonceStr,
        package: paymentData.package_str, // 根据新的返回结构修改
        signType: paymentData.signType,
        paySign: paymentData.paySign,
        cookie: `busid=wxapp; appid=${appid};; busid=wxapp; sessionid=SessionId%403041182606_13%231752982620731;; busid=wxapp; scene=1256;; busid=wxapp; scene_note=gh_9e2dbe88a92b%40app%3B%3B%3B0`,
        grantMessageQuota: true,
        requestId: Math.floor(Math.random() * 1000),
        commonUxInfo: "",
      };

      const invokeData = {
        args: JSON.stringify(args),
        miniprogramAppID: appid,
        name: "requestPayment",
        title: "发起支付",
        isBridgedJsApi: true,
        transitiveData: "",
        jsapiType: "appservice",
      };

      const finalPayload = {
        runtimeTicket: "Test",
        runtimeSessionId: "5435d6eafa9fe9cce1eb905ca37aa548",
        pathType: 1,
        reportUuid: `SessionId@3041182606_13#${Date.now() - 5000
          }_${Date.now()}`,
        reportWxaLibVersion: "3.8.11",
        deviceName: "WIN-1TV2F4I65G6",
        deviceId: "00-10-FE-6F-45-88",
        devicePlatform: "windows",
        clientVersion: "1661537335",
        invokeData: JSON.stringify(invokeData),
      };

      return finalPayload; // 返回对象而非字符串
    },
    formatPractice(item) {
      // 现在从 skuInfo 中直接获取规格信息
      if (item.skuInfo) {
        return Object.values(item.skuInfo).join(" , ");
      }
      const specs = (item.orderItemSpecList || []).map(
        (spec) => spec.specValue
      );
      const practices = (item.practiceList || []).map((p) => p.value);
      return [...specs, ...practices].join(" , ");
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-detail-page {
  padding-bottom: 100px;
  min-height: 100vh;
}

.order-details {
  padding: 16px;
}

.section-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--qm-text-muted);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 20px 0 10px;
  padding-left: 4px;
}

.shop-card {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 14px;

  .shop-icon {
    width: 44px;
    height: 44px;
    border-radius: var(--qm-radius-sm);
    background: rgba(245, 166, 35, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .van-icon {
      font-size: 22px;
      color: var(--qm-accent);
    }
  }

  .shop-info {
    flex: 1;
    min-width: 0;

    .shop-name {
      font-size: 16px;
      font-weight: 600;
      color: var(--qm-text-primary);
      margin-bottom: 4px;
    }

    .shop-address {
      font-size: 13px;
      color: var(--qm-text-secondary);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.order-items {
  padding: 4px 16px;

  .order-item {
    display: flex;
    padding: 14px 0;
    border-bottom: 1px solid var(--qm-border);
    align-items: center;
    gap: 12px;

    &:last-child {
      border-bottom: none;
    }
  }

  .item-image {
    width: 60px;
    height: 60px;
    border-radius: var(--qm-radius-sm);
    object-fit: cover;
    flex-shrink: 0;
    border: 1px solid var(--qm-border);
  }

  .item-info {
    flex: 1;
    min-width: 0;

    .item-name {
      font-size: 15px;
      font-weight: 600;
      color: var(--qm-text-primary);
    }

    .item-specs {
      font-size: 12px;
      color: var(--qm-text-muted);
      margin-top: 4px;
    }
  }

  .item-price {
    .count {
      font-size: 15px;
      font-weight: 600;
      color: var(--qm-accent);
    }
  }
}

.coupon-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: pointer;

  &:active {
    background: var(--qm-bg-card-hover);
  }

  .coupon-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    color: var(--qm-text-primary);

    .van-icon {
      color: var(--qm-accent);
      font-size: 18px;
    }
  }

  .coupon-right {
    display: flex;
    align-items: center;
    gap: 6px;

    .coupon-value {
      font-size: 14px;
      color: var(--qm-text-secondary);
    }

    .van-icon {
      color: var(--qm-text-muted);
      font-size: 14px;
    }
  }
}

.remark-box {
  padding: 4px 8px;

  :deep(.van-field__control) {
    color: var(--qm-text-primary);
  }

  :deep(.van-field__word-limit) {
    color: var(--qm-text-muted);
  }
}

.coupon-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--qm-bg-surface);

  .popup-title {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    padding: 20px 16px;
    color: var(--qm-text-primary);
    border-bottom: 1px solid var(--qm-border);
  }

  .coupon-list {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  .no-coupon {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--qm-text-muted);
  }

  .coupon-item {
    display: flex;
    margin-bottom: 12px;
    padding: 16px;
    align-items: center;
    cursor: pointer;
    transition: var(--qm-transition);

    &.active {
      border-color: var(--qm-accent);
      background: rgba(245, 166, 35, 0.08);
    }
  }

  .coupon-content {
    flex: 1;

    .coupon-name {
      font-size: 15px;
      font-weight: 600;
      color: var(--qm-text-primary);
    }
  }

  .coupon-checkbox {
    margin-left: 12px;
  }

  .popup-footer {
    padding: 12px 16px;
    border-top: 1px solid var(--qm-border);

    .van-button {
      height: 50px;
      font-size: 16px;
    }
  }
}
</style>